import type { WindowedCursorListRange } from '../../../hooks/useWindowedCursorList'
import type { IGrowthToolListItem } from '../../../api/types/growthTools'
import { VirtualCursorList } from '../../ui-kit/VirtualCursorList'
import { GrowthToolItem } from '../GrowthToolItem'

interface GrowthToolsListProps {
  growthTools: IGrowthToolListItem[]
  firstItemIndex?: number
  hasMore?: boolean
  isLoadingMore?: boolean
  onLoadMore?: () => void
  onStartReached?: () => void
  onRangeChanged?: (range: WindowedCursorListRange) => void
  emptyMessage?: string
}

export const GrowthToolsList = ({
  growthTools,
  firstItemIndex,
  hasMore,
  isLoadingMore,
  onLoadMore,
  onStartReached,
  onRangeChanged,
  emptyMessage = 'Нет инструментов для отображения',
}: GrowthToolsListProps) => {
  return (
    <VirtualCursorList
      items={growthTools}
      firstItemIndex={firstItemIndex}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onLoadMore={onLoadMore}
      onStartReached={onStartReached}
      onRangeChanged={onRangeChanged}
      getItemKey={(_index, growthTool) => growthTool.id}
      emptyMessage={emptyMessage}
      itemContent={(_index, growthTool) => <GrowthToolItem growthTool={growthTool} />}
    />
  )
}
